<template>
    <div :class="`convention-teaser-title ${mode} ${isChild ? 'child' : ''}`">
        <typo v-if="legend" class="legend" name="body-10-normal">
            {{ legend }}
        </typo>
        <typo :name="isChild ? 'body-16-medium' : 'body-16-medium'" with-icon="true">
            <book v-if="!isChild" />
            <pin v-if="isChild" />
            {{ convention.title }}
        </typo>
    </div>
</template>

<script>
import Pin from "src/components/common/icons/Pin.vue";
import Book from "src/components/common/icons/Book.vue";
import { getLegendText } from "src/utils/convention";

export default {
    components: { Book, Pin },
    props: ["convention", "mode"],
    computed: {
        legend() {
            return getLegendText(this.convention, this.isChild);
        },
        isChild() {
            return this.convention.parentConventionId;
        },
    },
};
</script>

<style scoped lang="sass">
.convention-teaser-title
    color: white

.legend
    padding-left: 30px

.book
    width: 17px
    height: 17px
    margin-left: 5px
    flex-shrink: 0
    position: relative
    top: -3px
    flex-shrink: 0

.pin
    width: 15px
    height: 15px
    margin-left: 4px
    position: relative
    top: -2px
    flex-shrink: 0

.icon
    fill: white

.convention-teaser-title.search-result
    color: $color-secondary

    .icon
        fill: $color-secondary

.convention-teaser-title.dashboard
    color: $color-secondary

    .icon
        fill: $color-secondary

@media print
    .icon
        display: none
    .legend
        padding-left: 0
</style>
